import { object, string } from 'yup'

export type Values = {
  email: string
  password: string
}

const schema = object<Values>({
  email: string().email('Email is incomplete').required('Email is required'),
  password: string().required('Password is required'),
})

export const useForm = (email?: string) => {
  const initialValues: Values = {
    email: email ?? '',
    password: '',
  }

  return { initialValues, schema } as const
}
